// Pause/Live toggle for the phones heatmap page. Hoists the live state
// to the parent so the page can swap React Query's refetchInterval.

interface LiveToggleProps {
  live: boolean
  onToggle: () => void
}

export function LiveToggle({ live, onToggle }: LiveToggleProps) {
  // role=switch with aria-checked is the right ARIA primitive — screen
  // readers announce "live, switch, on/off" instead of guessing from the
  // visible label.
  return (
    <button
      type="button"
      role="switch"
      aria-checked={live}
      onClick={onToggle}
      className={
        live
          ? 'inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium bg-emerald-600 text-white hover:bg-emerald-500 transition-colors'
          : 'inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-600 transition-colors'
      }
    >
      <span aria-hidden="true">{live ? '⏸' : '▶'}</span>
      <span>{live ? 'LIVE' : 'Пауза'}</span>
    </button>
  )
}
